import * as React from 'react';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { CoreTag, CoreTagsList as CoreTagList, } from '../internal/WixUiCoreComponents/components/CoreTagList';
import { st, classes } from './Tags.st.css';
import classnames from 'classnames';
import { TAGS_DATA_KEYS } from './dataHooks';
import { TagsAlignment, TagsSize, TagsSkin, } from './types';
/** A Selector Component */
export class Tags extends React.Component {
    getTagDataAttributes({ isChecked, index }) {
        return {
            [TAGS_DATA_KEYS.tagIsChecked]: isChecked,
            [TAGS_DATA_KEYS.index]: index,
        };
    }
    getTagsListDataAttributes({ alignment, skin, size, rtl }) {
        return {
            [TAGS_DATA_KEYS.alignment]: alignment,
            [TAGS_DATA_KEYS.skin]: skin,
            [TAGS_DATA_KEYS.size]: size,
            [TAGS_DATA_KEYS.rtl]: rtl,
        };
    }
    generateTagItems() {
        const { items, onClick } = this.props;
        return items.map((item, index) => (React.createElement(CoreTag, { tagIndex: index, key: item.value, checked: item.checked, onChange: () => onClick(item), disabled: item.disabled, link: item.link, rel: item.rel, value: item.value, className: classnames(classes.tag, {
                [classes.checked]: item.checked,
            }), ...this.getTagDataAttributes({
                isChecked: item.checked,
                index,
            }) }, item.title)));
    }
    render() {
        const { alignment, size, skin, className, lang } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => (React.createElement(CoreTagList, { "data-hook": this.props['data-hook'], ...this.getTagsListDataAttributes({
                alignment,
                skin,
                size,
                rtl,
            }), className: st(classes.root, {
                alignment,
                skin,
                size,
                rtl,
            }, className), lang: lang }, this.generateTagItems()))));
    }
}
Tags.displayName = 'Tags';
Tags.defaultProps = {
    alignment: TagsAlignment.center,
    size: TagsSize.medium,
    skin: TagsSkin.solid,
};
//# sourceMappingURL=Tags.js.map